package br.com.vvrefeicoes.portal.feature.juridico

import br.com.vvrefeicoes.portal.core.util.PdfLine
import br.com.vvrefeicoes.portal.core.util.PdfReport
import br.com.vvrefeicoes.portal.core.util.PdfWriter
import br.com.vvrefeicoes.portal.core.util.encodeBase64
import br.com.vvrefeicoes.portal.core.util.saveFile
import br.com.vvrefeicoes.portal.core.util.savePdf
import br.com.vvrefeicoes.portal.domain.model.JuridicoProcesso

internal fun exportProcessosCsv(processos: List<JuridicoProcesso>): Boolean {
    val columns =
        listOf(
            "Empresa",
            "CNPJ",
            "Número do processo",
            "Tribunal",
            "Órgão/Vara",
            "Assunto",
            "Classe",
            "Status",
            "Autor",
            "Réu",
            "Juiz",
            "Esfera",
            "Rito",
            "Instância",
            "Estratégico",
            "Valor",
            "Última movimentação",
            "Unidades",
            "Link externo",
        )
    val rows =
        processos.map { process ->
            listOf(
                process.empresaNome,
                process.empresaCnpj,
                process.numeroCnj,
                process.tribunal,
                process.orgaoVara,
                process.assunto,
                process.classe,
                process.status,
                process.autor,
                process.reu,
                process.juiz,
                process.esfera,
                process.rito,
                process.instancia,
                if (process.estrategico) "Sim" else "Não",
                process.valorCausa?.toString().orEmpty(),
                process.ultimaMovimentacao?.toBrazilianDate().orEmpty(),
                process.unidades.joinToString { it.nome },
                process.linkExterno.orEmpty(),
            )
        }
    val csv =
        buildString {
            append('\uFEFF')
            appendLine(columns.joinToString(";") { it.csvValue() })
            rows.forEach { appendLine(it.joinToString(";") { value -> value.csvValue() }) }
        }
    return saveFile("processos-juridicos.csv", "text/csv;charset=utf-8", csv.encodeToByteArray())
}

internal fun exportProcessosPdf(processos: List<JuridicoProcesso>): Boolean {
    val lines =
        buildList {
            add(PdfLine.Title("Oficiais e Tribunais - Processos"))
            add(PdfLine.Text("Relatório dos processos jurídicos carregados na tela."))
            add(PdfLine.Divider)
            processos.forEach { process ->
                add(PdfLine.Heading(process.numeroCnj))
                add(PdfLine.Row("Empresa", process.empresaNome))
                add(PdfLine.Row("Tribunal", process.tribunal))
                add(PdfLine.Row("Status", process.status))
                add(PdfLine.Row("Assunto", process.assunto))
                add(PdfLine.Row("Valor", process.valorCausa?.toString().orEmpty()))
                add(PdfLine.Row("Unidades", process.unidades.joinToString { it.nome }.ifBlank { "Nenhuma" }))
                add(PdfLine.Divider)
            }
        }
    return savePdf("processos-juridicos.pdf", encodeBase64(PdfWriter.build(PdfReport(lines))))
}

private fun String.csvValue(): String = "\"${replace("\"", "\"\"")}\""
